module.exports = __webpack_public_path__ + "img/SentimentDissatisfiedOutlined.5425da9e.svg";